import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_PagedPriceListGet, Model_PriceListPost, Model_ProductTypeGet } from "src/backend/openapi/v1";

export enum Action {
  GetPriceListRequest = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:GETPRICELISTREQUEST",
  GetPriceListSuccess = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:GETPRICELISTSUCCESS",
  GetPriceListFail = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:GETPRICELISTFAIL",

  GetProductTypesRequest = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:GETPRODUCTTYPESREQUEST",
  GetProductTypesSuccess = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:GETPRODUCTTYPESSUCCESS",
  GetProductTypesFail = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:GETPRODUCTTYPESFAIL",

  Clear = "@@ITK:SRC:PAGES:PRICE-LIST:PRICE-LIST-STORE.TS:ACTION:CLEAR"
}

type priceListState = {
  priceListState: Loading<Model_PagedPriceListGet>;
  productTypes: Loading<Model_ProductTypeGet[]>;
};

const initialState: priceListState = {
  priceListState: loadingNotStarted,
  productTypes: loadingNotStarted
};

export const priceListActions = {
  getPriceListRequest: (data: Model_PriceListPost) => actionCreator(Action.GetPriceListRequest, { data }),
  getPriceListSuccess: (data: Model_PagedPriceListGet) => actionCreator(Action.GetPriceListSuccess, { data }),
  getPriceListFail: () => actionCreator(Action.GetPriceListFail),

  getProductTypesRequest: () => actionCreator(Action.GetProductTypesRequest),
  getProductTypesSuccess: (data: Model_ProductTypeGet[]) => actionCreator(Action.GetProductTypesSuccess, { data }),
  getProductTypesFail: () => actionCreator(Action.GetProductTypesFail),

  clear: () => actionCreator(Action.Clear)
};

export const priceListReducer = (state = initialState, action: ActionReturnType<typeof priceListActions>): priceListState => {
  switch (action.type) {
    case Action.GetPriceListRequest:
      return { ...state, priceListState: loadingIsLoading };
    case Action.GetPriceListSuccess:
      return { ...state, priceListState: loadingFinished(action.payload.data) };
    case Action.GetPriceListFail:
      return { ...state, priceListState: loadingFailed };

    case Action.GetProductTypesRequest:
      return { ...state, productTypes: loadingIsLoading };
    case Action.GetProductTypesSuccess:
      return { ...state, productTypes: loadingFinished(action.payload.data) };
    case Action.GetProductTypesFail:
      return { ...state, productTypes: loadingFailed };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
